export default "__VITE_ASSET__Gl5gy6mp__"